// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 705 ? "dc112a36" : chunkId) + "." + {"669":"9dfdf71538fdb9b8","705":"1b819be7b82b54d8"}[chunkId] + ".js";
};